export default "__VITE_ASSET__DnTW7IcD__"